import { createSelector } from 'reselect'

const _userDraftComments = state => {
  if (state.quest.section === 'activities') {
    return state.quest.userActivityComments.filter(
      c => c.resource_id === state.quest.activityId
    )
  } else {
    return state.quest.userComments.filter(
      c => c.section === state.quest.section
    )
  }
}

export const userDraftComments = createSelector(
  [_userDraftComments],
  comments => {
    return comments
  }
)



// WEBPACK FOOTER //
// ./src/selectors/userdraftcomments.js